import { Component } from '@angular/core';
import { FieldTypeConfig } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material';
import { FormlyFieldProps } from '@ngx-formly/material/form-field';

import { slideInTop } from '@lockton-apps/shared/ui/lui';

interface MatCheckboxProps extends FormlyFieldProps {
  indeterminate?: boolean;
  labelPosition?: 'before' | 'after';
}

interface CheckboxProps extends MatCheckboxProps {
  htmlLabel: string;
}

@Component({
    selector: 'lockton-apps-checkbox-type',
    templateUrl: './checkbox-type.component.html',
    styleUrls: ['./checkbox-type.component.scss'],
    animations: [slideInTop],
    standalone: false
})
export class CheckboxTypeComponent extends FieldType<
  FieldTypeConfig<CheckboxProps>
> {}
